import { useState, useEffect, useMemo } from "react";
import Layout from "../layouts/layout";
import Items from "../containers/_employees/items";
import Employee from "../containers/_employees/employee";
import EMPLOYEES from "../api/services/EMPLOYEES";
import Loader from "../components/loader";
import styles from "../styles/_screens/employees.module.scss";
import { toast } from "react-toastify";
import { ConfirmModal } from "../components/confirmModal";

const Employees = () => {
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const [employees, setEmployees] = useState(null);

  const [resStatus, setResStatus] = useState(null);

  const [selectedEmployee, setSelectedEmployee] = useState(null);

  let businessId = localStorage.getItem("user_id");
  businessId = JSON.parse(businessId);

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [confirmModalLoading, setConfirmModalLoading] = useState(false);

  // DELETE EMPLOYEE
  const deleteEmployee = async () => {
    setConfirmModalLoading(true)
    try {
      const res = await EMPLOYEES.del(isConfirmModalOpen);
      if (res.status === 200) {
        toast.success(res.data.message);
        setIsConfirmModalOpen(false)
        setResStatus(true);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
    setConfirmModalLoading(false)
  };

  // FETCH EMPLOYEES
  useEffect(() => {
    setResStatus(null);
    const fetchData = async () => {
      try {
        const res = await EMPLOYEES.get(businessId);
        setEmployees(res.data.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, [resStatus]);

  const filteredEmployees = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return employees || [];
    return (employees || []).filter((employee) =>
      [employee.name, employee.business_phone, employee.phone]
        .filter(Boolean)
        .some((value) => String(value).toLowerCase().includes(query))
    );
  }, [employees, search]);

  const employeesWithPhone = useMemo(
    () => (employees || []).filter((employee) => employee.business_phone || employee.phone).length,
    [employees]
  );

  if (!employees) {
    return (
      <Layout>
        <div className={styles.container}>
          <div className={styles.wrapper}>
            <div className={styles.main}>
              <Loader />
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <header className={styles.pageHeader}>
            <div className={styles.headingBlock}>
              <span className={styles.headingIcon} aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none"><circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="1.8" /><path d="M2.5 20v-1a6.5 6.5 0 0 1 13 0v1M17 9.5a3.5 3.5 0 0 1 0 7M19 20v-.8c0-1.2-.4-2.3-1.1-3.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>
              </span>
              <div>
                <h1>עובדים וצוות</h1>
                <p>ניהול אנשי הצוות, שעות הקבלה והשירותים שהם מעניקים</p>
              </div>
            </div>
            <button
              type="button"
              className={styles.addEmployeeBtn}
              onClick={() => {
                setSelectedEmployee(null);
                setIsOpen("create");
              }}
            >
              <svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 4v12M4 10h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
              עובד חדש
            </button>
          </header>

          <div className={styles.toolbar}>
            <div className={styles.summary}>
              <div><strong>{employees.length}</strong><span>אנשי צוות</span></div>
              <span className={styles.divider} />
              <div><strong>{employeesWithPhone}</strong><span>זמינים ליצירת קשר</span></div>
            </div>
            <div className={styles.searchBox}>
              <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="6.5" stroke="currentColor" strokeWidth="1.8" /><path d="m16 16 4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>
              <input
                type="search"
                value={search}
                onChange={(event) => setSearch(event.target.value)}
                placeholder="חיפוש עובד לפי שם או טלפון..."
                aria-label="חיפוש עובד"
              />
              {search && <button type="button" onClick={() => setSearch("")} aria-label="ניקוי החיפוש">×</button>}
            </div>
          </div>

          <div className={styles.main}>
            <Items
              data={filteredEmployees}
              hasSearch={Boolean(search.trim())}
              setIsOpen={setIsOpen}
              setSelectedEmployee={setSelectedEmployee}
              setIsConfirmModalOpen={setIsConfirmModalOpen}
            />
            {isOpen && (
              <Employee
                isOpen={isOpen}
                selectedEmployee={selectedEmployee}
                businessId={businessId}
                setResStatus={setResStatus}
                setIsOpen={setIsOpen}
              />
            )}
          </div>
        </div>
        {isConfirmModalOpen && (
          <ConfirmModal
            setIsOpen={setIsConfirmModalOpen}
            handleClick={() => deleteEmployee(isConfirmModalOpen)}
            loading={confirmModalLoading}
          />
        )}
      </div>
    </Layout>
  );
};

export default Employees;
